import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Play } from "lucide-react";
import api from "../api";
import { fmtQty } from "../lib/utils";

// v414.25 — VIDEO PLAYS: storefront explainer-clip play counts for this
// store (distributor's own view + god-mode ?as=). Renders nothing until the
// store has at least one recorded play.
export const VideoViewsCard = ({ asParams }) => {
  const { t } = useTranslation();
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get("/my-store/video-views", { params: asParams })
      .then(({ data }) => setRows(data || []))
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [asParams?.as]);

  if (rows.length === 0) return null;

  return (
    <div className="bg-white border border-zinc-200 rounded-xl p-4 space-y-2" data-testid="video-views-card">
      <div>
        <h2 className="text-sm font-semibold flex items-center gap-2">
          <span className="w-5 h-5 rounded-full flex items-center justify-center bg-[#fbf6e7] border border-[#c9a24a]">
            <Play size={10} fill="#8a6a1c" color="#8a6a1c" />
          </span>
          {t("my_store.video_views_title")}
        </h2>
        <p className="text-[11px] text-zinc-500 mt-0.5">{t("my_store.video_views_sub")}</p>
      </div>
      <div className="divide-y divide-zinc-100">
        {rows.slice(0, 10).map((r) => (
          <div key={r.video_name} className="py-1.5 flex items-center gap-2 text-[13px]"
            data-testid={`video-views-row-${r.video_name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
            <span className="font-medium text-zinc-900 truncate flex-1">{r.video_name}</span>
            <span className="text-[10px] text-zinc-400 font-mono shrink-0">
              {["en", "ru", "fr"].filter((l) => r[`count_${l}`])
                .map((l) => `${l.toUpperCase()} ${fmtQty(r[`count_${l}`])}`).join(" · ")}
            </span>
            <span className="font-bold text-[#8a6a1c] tabular-nums shrink-0">{fmtQty(r.count)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
